import IconMicrosoftBands from '@/assets/icons/font_awesome/microsoft-brands.svg?react';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_settings_user from '@/locales/keys/i18n_page_settings_user.json';
import { ButtonSocialNetwork } from '@/pages/_base/buttons/ButtonSocialNetwork';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_user_auth_provider_microsoft_unlink } from '@/state/user/auth/providers/remote_user_auth_provider_microsoft_unlink';
import { is_unlink_disabled } from '@/utils/utils_auth';
import { ENUM__http_route } from '@shared/network/ENUM__http_route';
import { useTranslation } from 'react-i18next';

function ButtonLinkMicrosoft() {
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_USER);
  const { microsoft_email } = use_slice_user(['microsoft_email']);

  return (
    <div className="flex gap-2 items-center">
      <ButtonSocialNetwork
        start_slug={ENUM__http_route.MICROSOFT_AUTH_START}
        linked={Boolean(microsoft_email)}
        unlink_func={() => dispatch(remote_user_auth_provider_microsoft_unlink())}
        disabled={is_unlink_disabled(microsoft_email)}
      >
        <IconMicrosoftBands className="size-4 !text-bar-foreground" />
        <span className="text-bar-foreground">
          {microsoft_email
            ? t(i18n_page_settings_user.tabs.account.social_networks_component.button.microsoft_email.unlink)
            : t(i18n_page_settings_user.tabs.account.social_networks_component.button.microsoft_email.link)}
        </span>
      </ButtonSocialNetwork>
      <a>{microsoft_email}</a>
    </div>
  );
}

export default ButtonLinkMicrosoft;
